import EnumIconSvg from '../../assets/icons/enum.svg?react';
import type { CSSProperties } from 'react';

export interface IconProps {
    size?: number | string;
    className?: string;
    style?: CSSProperties;
    onClick?: () => void;
}

const EnumIcon: React.FC<IconProps> = ({ 
    size = 16, 
    className = '', 
    style = {},
    onClick 
}) => {
    const iconStyle: CSSProperties = {
        width: typeof size === 'number' ? `${size}px` : size,
        height: typeof size === 'number' ? `${size}px` : size,
        display: 'inline-block',
        fill: 'currentColor',
        ...style,
    };

    return (
        <EnumIconSvg 
            className={className}
            style={iconStyle}
            onClick={onClick}
        />
    );
};

export default EnumIcon;
